import { Seo } from "../components/site/Seo";
import { PageHero } from "../components/site/PageHero";
import { SITE } from "../lib/site";

function Prose({ children }) {
  return <section className="px-5 py-16 lg:px-8"><div className="legal mx-auto max-w-[820px] text-base leading-relaxed text-slate-700">{children}</div></section>;
}

export function MentionsLegales() {
  return (
    <>
      <Seo title="Mentions légales | A+GLASS Pare-Brise HAGUENAU" description="Mentions légales du site A+GLASS Pare-Brise HAGUENAU." path="/mentions-legales" />
      <PageHero eyebrow="Informations légales" title="Mentions légales" crumbs={[{ to: "/", label: "Accueil" }, { to: "/mentions-legales", label: "Mentions légales" }]} />
      <Prose>
        <h2>Éditeur du site</h2>
        <p>{SITE.name}<br />{SITE.street}, {SITE.zip} {SITE.city}, France<br />Téléphone : {SITE.phone}<br />Email : {SITE.email}</p>
        <p>Raison sociale : [à compléter]<br />Forme juridique et capital : [à compléter]<br />SIRET : [à compléter]<br />RCS : [à compléter]<br />N° TVA intracommunautaire : [à compléter]<br />Directeur de la publication : [à compléter]</p>
        <p>A+ Glass est une marque du réseau A+ Glass. L'établissement {SITE.name} est exploité par [raison sociale à compléter].</p>
        <h2>Hébergement</h2>
        <p>[Nom, adresse et téléphone de l'hébergeur à compléter]</p>
        <h2>Propriété intellectuelle</h2>
        <p>L'ensemble des contenus de ce site (textes, visuels, logos) est protégé. Toute reproduction sans autorisation est interdite.</p>
        <h2>Crédits photos</h2>
        <p>Logo et photos du centre (façade, accueil) : A+ Glass / A+GLASS Pare-Brise HAGUENAU. Badge « Meilleur Garage de France 2026 » : Allogarage. Autres photographies : Unsplash.</p>
      </Prose>
    </>
  );
}

export function Confidentialite() {
  return (
    <>
      <Seo title="Politique de confidentialité et cookies | A+ Glass Haguenau" description="Politique de confidentialité, données personnelles et gestion des cookies du site A+GLASS Pare-Brise HAGUENAU." path="/politique-confidentialite" />
      <PageHero eyebrow="Données personnelles" title="Politique de confidentialité" crumbs={[{ to: "/", label: "Accueil" }, { to: "/politique-confidentialite", label: "Confidentialité" }]} />
      <Prose>
        <h2>Responsable du traitement</h2>
        <p>{SITE.name}, {SITE.street}, {SITE.zip} {SITE.city}. Contact : {SITE.email}.</p>
        <h2>Données collectées</h2>
        <p>Via les formulaires de devis, de rendez-vous, de rappel et de contact : nom, prénom, téléphone, email, ville, adresse, informations sur le véhicule (type, marque, modèle, immatriculation), message et photos éventuelles.</p>
        <h2>Finalités</h2>
        <p>Ces données sont utilisées uniquement pour répondre à votre demande (devis, rendez-vous, rappel) et assurer le suivi de votre intervention. Elles ne sont ni vendues ni cédées.</p>
        <h2>Durée de conservation</h2>
        <p>[Durée de conservation à compléter par l'établissement]</p>
        <h2>Vos droits</h2>
        <p>Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement, d'opposition et de limitation. Pour l'exercer : {SITE.email}. Vous pouvez également saisir la CNIL (www.cnil.fr).</p>
        <h2 id="cookies">Gestion des cookies</h2>
        <p>Le site n'utilise pas de cookies publicitaires. Des cookies strictement nécessaires peuvent être déposés pour le fonctionnement de l'espace d'administration. La carte Google Maps intégrée peut déposer des cookies propres à Google lors de son affichage.</p>
        <p>Si un outil de mesure d'audience est activé, il ne sera chargé qu'après votre consentement via le bandeau prévu à cet effet.</p>
      </Prose>
    </>
  );
}
